import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Home from './pages/Home';
import Providers from './pages/Providers';
import ProviderDetail from './pages/ProviderDetail';
import ProviderForm from './pages/ProviderForm';
import Services from './pages/Services';
import Locations from './pages/Locations';
import AddLocation from './pages/AddLocation';
import EditLocation from './pages/EditLocation';
import Roles from './pages/Roles';
import AddRole from './pages/AddRole';
import EditRole from './pages/EditRole';
import Settings from './pages/Settings';
import Appointments from './pages/Appointments';
import TCR from './pages/TCR';
import useAuthStore from './stores/authStore';

const Router = () => {
	const { isAuthenticated } = useAuthStore();

	return (
		<Routes>
			{/* Public Routes */}
			<Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />

			{/* Protected Routes */}
			<Route
				path="/"
				element={
					<ProtectedRoute>
						<Navigate to="/dashboard" replace />
					</ProtectedRoute>
				}
			/>

			<Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<Home />
					</ProtectedRoute>
				}
			/>

			{/* Super Admin Routes */}
			<Route
				path="/providers"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN']}>
						<Providers />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/providers/new"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN']}>
						<ProviderForm />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/providers/:id/edit"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN']}>
						<ProviderForm />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/providers/:id"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN']}>
						<ProviderDetail />
					</ProtectedRoute>
				}
			/>

			{/* Salon Owner/Manager Routes */}
			<Route
				path="/services"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<Services />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/locations"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<Locations />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/locations/new"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<AddLocation />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/locations/:id/edit"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<EditLocation />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/roles"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<Roles />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/roles/new"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<AddRole />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/roles/:id/edit"
				element={
					<ProtectedRoute allowedRoles={['SALON_OWNER', 'MANAGER']}>
						<EditRole />
					</ProtectedRoute>
				}
			/>

			{/* Common Routes (placeholders) */}
			<Route
				path="/bookings"
				element={
					<ProtectedRoute>
						<Appointments />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/tcr"
				element={
					<ProtectedRoute allowedRoles={['STAFF', 'SALON_OWNER', 'MANAGER']}>
						<TCR />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/approvals"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN', 'SALON_OWNER', 'MANAGER']}>
						<div>Approvals (Coming Soon)</div>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/inventory"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN', 'SALON_OWNER', 'MANAGER']}>
						<div>Inventory (Coming Soon)</div>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/commissions"
				element={
					<ProtectedRoute>
						<div>Commissions (Coming Soon)</div>
					</ProtectedRoute>
				}
			/>
			<Route
				path="/settings"
				element={
					<ProtectedRoute allowedRoles={['SUPER_ADMIN', 'SALON_OWNER', 'MANAGER']}>
						<Settings />
					</ProtectedRoute>
				}
			/>

			{/* Fallback */}
			<Route path="*" element={<Navigate to="/dashboard" replace />} />
		</Routes>
	);
};

export default Router;
